/**
 * Muhit o'zgaruvchilari — TIPLI kirish.
 *
 * `import.meta.env` ning indeks tipi `any`, shuning uchun unga
 * to'g'ridan-to'g'ri murojaat qilinmaydi: `any` butun zanjir bo'ylab
 * tarqaladi va `tsc` xatoni ushlay olmay qoladi (CLAUDE.md → 1-taqiq).
 */
interface ViteEnv {
  readonly VITE_API_BASE_URL?: string;
  readonly VITE_MEDIA_ORIGIN?: string;
}

const env = import.meta.env as unknown as ViteEnv;

/** API manzili. Bo'sh bo'lsa nisbiy yo'l ishlatiladi (bir domenda). */
export const API_BASE_URL = (env.VITE_API_BASE_URL ?? '').replace(/\/+$/, '');

/** Lokal MinIO rasmlarini telefonda sinash uchun ixtiyoriy HTTPS origin. */
export const MEDIA_ORIGIN = env.VITE_MEDIA_ORIGIN ?? '';
